import { isSameDay, parseDate } from '@internationalized/date'

import { LATEST_DAY } from '@hooks/useSelectedDay'

import type { DateValue } from 'react-aria-components'

/** The backend groups days and sends them newest first; this only navigates that list. */
export function calculateStoreDays(days: { day: string }[], selectedDay: string) {
  const available = days.map(({ day }) => parseDate(day)).sort((a, b) => a.compare(b))

  const currentIndex = selectedDay === LATEST_DAY
    ? available.length - 1
    : available.findIndex(day => day.toString() === selectedDay)

  const hasCurrent = currentIndex >= 0

  return {
    currentDay: hasCurrent ? available[currentIndex] : undefined,
    previousDay: hasCurrent ? available[currentIndex - 1] : undefined,
    nextDay: hasCurrent ? available[currentIndex + 1] : undefined,
    minDay: available[0],
    maxDay: available[available.length - 1],
    isDayAvailable: (date: DateValue) => available.some(day => isSameDay(day, date)),
  }
}
